/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {getters} from '@/store/modules/settings/getters';
import {actions} from '@/store/modules/settings/actions';
import {mutations} from '@/store/modules/settings/mutations';
import {SettingStateInterface} from '@/store/modules/settings/types';

/**
 * The application settings store module.
 *
 * This module is imported by vuex as a representation of the application settings.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export const state: SettingStateInterface = {
    media: [],
    language: '',
    consent: false,
    pageTitle: '',
    mastheadImage: undefined,
    backgroundImage: undefined,
};

const namespaced: boolean = true;

export const settingsModule: Module<SettingStateInterface, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
